<template>
  <div :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <Clipper v-if="isClipper" v-on:setPhoto="setPhoto" :userUrl="photo_url" v-on:close="close" />
    <!-- <div class="banner h-32 md:h-56 relative">
      <div class="flex absolute member items-center">
        <div class="photo p-4 md:p-6 bg-gray-400 mr-4 rounded-full flex justify-center items-center relative overflow-hidden" v-if="!photo_url">
          <font-awesome-icon icon="user" class="text-white text-2xl md:text-4xl" />
          <span class="absolute w-full bg-gray-800 text-white text-center text-sm change_profile cursor-pointer" @click="isClipper = true">變更</span>
        </div>
        <div class="user-photo bg-gray-400 mr-4 rounded-full flex justify-center items-center relative overflow-hidden" v-if="photo_url" :style="'backgroundImage:url('+ photo_url + ')'">
          <span class="absolute w-full bg-gray-800 text-white text-center text-sm change_profile cursor-pointer" @click="isClipper = true">變更</span>
        </div>
        <div class="memberName flex md:items-center text-NotoSansRegular flex-col">
          <p class="text-2xl font-bold mr-3 mb-0 textColorDarkBlack whitespace-no-wrap">{{ user.name }}</p>
            <span class="textColorRed text-xs" v-if="!user.email_verified_at">※尚未通過 E-MAIL驗證</span>
        </div>
      </div>
    </div> -->
    <div class="banner h-32 md:h-56 relative">
      <div class="flex absolute member items-center">
        <div class="photo bg-gray-400 mr-4 rounded-full flex justify-center items-center">
          <font-awesome-icon icon="user" class="text-white font-user" />
        </div>
        <div class="memberName flex md:items-center text-NotoSansRegular flex-col">
          <p class="text-xl font-bold mr-3 mb-0 textColorDarkBlack whitespace-no-wrap">{{ user.name }}</p>
            <span class="textColorRed text-xs" v-if="!user.email_verified_at">※尚未通過 E-MAIL驗證</span>
        </div>
      </div>
    </div>
    <div class="lg:py-6 xl:py-8 px-2 md:px-6 max-w-7xl mx-auto">
      <div class="main">
          <div class="flex flex-wrap">
            <div class="w-full lg:w-3/12 lg:pr-3 xl:pr-4 mb-1 lg:mb-0">
              <MemberMenu />
            </div>
            <div class="w-full lg:w-9/12 lg:pl-3 xl:pl-4">
              <router-view></router-view>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MemberMenu from '@/components/member/MemberMenu'
import Clipper from '@/components/modules/Clipper'
export default {
  name: 'User',
  metaInfo () {
    return {
      title: '會員中心',
      titleTemplate: null
    }
  },
  data () {
    return {
      isClipper: false,
      photo_url: ''
    }
  },
  components: {
    MemberMenu,
    Clipper
  },
  computed: {
    ...mapGetters([
      'authorized',
      'user'
    ])
  },
  mounted () {
    this.checkAuthorized()
  },
  methods: {
    checkAuthorized () {
      if (!this.authorized) {
        this.$router.push({ name: 'login' })
      } else {
        this.$store.dispatch('getProfile')
      }
    },
    setPhoto (setPhoto) {
      let self = this
      self.photo_url = setPhoto

      self.close()
    },
    close (close) {
      this.isClipper = close
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  background-image: url('~@/assets/images/banner/member.webp');
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
  height: 0;
  .member {
    left: 20%;
    top: 30%;
    @media (max-width: 769px) {
      left: 10%;
    }
    @media (max-width: 321px) {
      left: 5%;
    }
    .photo {
      width: 80px;
      height: 80px;
      @media (max-width: 769px) {
        width: 60px;
        height: 60px;
      }
      .font-user {
        font-size: 2rem;
        @media (max-width: 769px) {
          font-size: 1.5rem;
        }
      }
      .change_profile {
        transition: .3s;
        bottom: -1.5em;
      }
      &:hover {
        .change_profile {
          transition: .3s;
          bottom: .5em;
        }
      }
    }
    .user-photo {
        width: 100px;
        height: 100px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        @media (max-width: 769px) {
          width: 60px;
          height: 60px;
        }
      .change_profile {
        transition: .3s;
        bottom: -1.5em;
      }
      &:hover {
        .change_profile {
          transition: .3s;
          bottom: .5em;
        }
      }
    }
  }
}
</style>
